// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"fce399e5","114":"5d5d563c","201":"9d812329","261":"d5295ec0","335":"28d4e869","336":"f14d2ded","355":"1fd05948","371":"2f23ddb1","377":"77fd21d2","458":"2b4c5933","484":"6f49e2ef","519":"62214d4b","676":"d9eb5589","686":"9288d7c7","849":"cd33ee5f","896":"2571ecb9"}[chunkId] + ".chunk.js";
};